import { api } from 'api';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export default (enabled = true) => {
  const { data: countryInfo } = useQuery({
    queryKey: queryKeys.ipCountry(),
    queryFn: async () => {
      const { data } = await api.getCountryInfo();

      return data;
    },

    enabled,
  });

  return countryInfo;
};
